<template> 
  <aside class='col'>  
    <ul class="none-p-m">  
 
      <li class='pb-2'>
        <div class="d-flex align-items-center justify-content-between" @click="showFiltersProgram = !showFiltersProgram">
          <a v-text="$ml.get('program')+'s'" > Programa </a>
          <div class="pointer" style="padding-right: 18px;">
            <svg width="26" height="26" >
              <image
                v-if="!showFiltersProgram"
                xlink:href="../../../src/assets/svg/arrow-drop-fill.svg"
                width="26"
                height="26"
              />
              <image
                v-else
                xlink:href="../../../src/assets/svg/arrow-up-fill.svg"
                width="26"
                height="26"
              />
            </svg>
          </div>
        </div>
        <div class="input-group mt-1" style="padding-right: 22px;" v-if="showFiltersProgram && program.length">
          <input
            class="form-control filterInput"
            v-model="txtSearchProgram"
            :placeholder="$ml.get('search')"
            aria-label="Search"
            style="border-right: none"
          />
          <div class="input-group-append">
            <div
              class="input-group-text"
              style="background-color: #fff"
            >
              <svg width="20" height="20" class="mt-1">
                <image
                  xlink:href="../../../src/assets/icons/search_s.svg"
                  width="18"
                  height="18"
                />
              </svg>
            </div>
          </div>
        </div>
        <ul class='none-p-m pt-2 pb-3'>
          <li :class="!programS ? 'active py-1' :'py-1'">
            <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
            <a @click="programS = '',changeProgram()" v-text="$ml.get('all')"> Todos </a>
          </li>
          <li v-for="(item, index) in listProgram" :key="index" :class="programS == item.program_id ? 'active py-1' :'py-1'">
            <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
            <a @click="programS = item.program_id,changeProgram()" v-text="item.name"></a>
          </li> 
        </ul>
      </li>
      
      <li v-if="status?.length" class='pb-2'>
        <a> Status </a>
        <ul class='none-p-m pt-2 pb-3'>
          <li v-if="status?.length > 1" :class="!statusS ? 'active py-1' :'py-1'">
            <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
            <a @click="statusS = '',changeProgram()" v-text="$ml.get('all')"> 
              Todos
            </a>
          </li>
          <li v-for="(item, index) in status" :key="index" 
            :class="statusS == item ? 'active py-1' :'py-1'"
            @click="statusS = item,changeProgram()">
            <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
            <a v-if="item == 'closed'" v-text="$ml.get('closed')"> Fechado </a> 
            <a v-if="item == 'open'" v-text="$ml.get('open')"> Aberto </a>
          </li> 
        </ul>
      </li>

      <li v-if="situations?.length" class='pb-2'>
        <a v-text="$ml.get('situation')"> Situação </a>
        <ul class='none-p-m pt-2 pb-3'>
          <div v-if="model != 'triaged'">
            <li v-if="situations?.length > 1" :class="!situationsS ? 'active py-1' :'py-1'"
              @click="situationsS = '',changeProgram()">
              <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i>
              <a v-text="$ml.get('all')"> Todos </a>
            </li>
          </div>
          <div v-if="model != 'triaged'">
            <li v-for="(item, index) in situations" :key="index"
              :class="[situationsS == item ? 'active py-1 text-capitalize' : 'py-1 text-capitalize', model == item ? 'active py-1 text-capitalize' : '' ]"
              @click="situationsS = item, changeProgram()">
              <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i>
              <a v-if="item == 'approved'"  v-text="$ml.get('approved')?.toLowerCase()">Aprovado </a>
              <a v-if="item == 'duplicated'" v-text="$ml.get('duplicated')?.toLowerCase()"> Duplicado </a>
              <a v-if="item == 'informative'"  v-text="$ml.get('informative')?.toLowerCase()"> Informativo </a>
              <a v-if="item == 'needs_information'" v-text="$ml.get('needsInformation')?.toLowerCase()"> Necessita de informação </a>
              <a v-if="item == 'new'" v-text="$ml.get('new')?.toLowerCase()"> Novo </a>
              <a v-if="item == 'not_applicable'" v-text="$ml.get('not_applicable')?.toLowerCase()"> Não aplicável </a>
              <a v-if="item == 'under_review'" v-text="$ml.get('under_review')?.toLowerCase()"> Em revisão </a>
              <a v-if="item == 'spam'"> Spam </a>
              <a v-if="item == 'triaged'" v-text="$ml.get('triaged')?.toLowerCase()"> Triado </a>
              <a v-if="item == 'retest_done'" v-text="$ml.get('retest_done')?.toLowerCase()"> Retest Concluido </a>
              <a v-if="item == 'pending_retest'" v-text="$ml.get('pending_retest')?.toLowerCase()"> Retest Pendente </a>
             </li>
          </div>
           <li v-else class="active py-1 text-capitalize"><a v-text="$ml.get('triaged')?.toLowerCase()"> Triado </a></li>

        </ul>
      </li>

      <li v-if="severity?.length" class='pb-2'>
        <a v-text="$ml.get('impact')"> Impacto </a>
        <ul class='none-p-m pt-2 pb-3'>
          <li v-if="severity?.length > 1" :class="!severityS ? 'active py-1' :'py-1'"
            @click="severityS = '',changeProgram()">
            <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
            <a v-text="$ml.get('all')"> Todos </a>
          </li>
          <li v-for="(item, index) in severity" 
            :key="index" :class="severityS == item ? 'active py-1' :'py-1'"
            @click="severityS = item,changeProgram()">
            <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
            <a v-if="item == 'low'" v-text="$ml.get('low')"> Baixo </a>
            <a v-if="item == 'medium'" v-text="$ml.get('medium')"> Médio </a>
            <a v-if="item == 'high'" v-text="$ml.get('high')"> Alto </a>
            <a v-if="item == 'critical'" v-text="$ml.get('critical')"> Crítico </a>
          </li> 
        </ul>
      </li>

      <li v-if="program_types?.length" class='pb-2'>
        <a v-text="$ml.get('programType')"> Tipo de Programa </a>
        <ul class='none-p-m pt-2 pb-3'>
          <li v-if="program_types?.length > 1" :class="!program_typesS ? 'active py-1' :'py-1'"
            @click="program_typesS = '',changeProgram()">
            <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
            <a v-text="$ml.get('all')"> Todos </a>
          </li>
          <li v-for="(item, index) in program_types" 
            :key="index" :class="program_typesS == item ? 'active py-1' :'py-1'"
            @click="program_typesS = item,changeProgram()">
            <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
            <a v-if="item == 'public'" v-text="$ml.get('public')"> Público </a>
            <a v-if="item == 'private'" v-text="$ml.get('private')"> Privado </a>
            <a v-if="item == 'vdp'" > VDP</a>
          </li>
        </ul>
      </li>

      <li v-if="period?.length" class='pb-2'>
        <a v-text="$ml.get('time')"> Tempo </a>
        <ul class='none-p-m pt-2 pb-3'>
          <li :class="!periodS ? 'active py-1' :'py-1'"
            @click="periodS = '',changeProgram()">
            <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
            <a v-text="$ml.get('all')" :class="!periodS ? 'active' : ''"> Todos </a>
          </li>
          <li v-for="(item, index) in period" 
            :key="index" :class="periodS == item ? 'active py-1' :'py-1'"
            @click="periodS = item,changeProgram()">
            <i><img src="../../../src/assets/icons/angle-right.svg" class="ico-16 mb-1"/></i> 
            <a v-if="item == 'last_day'" v-text="$ml.get('oneDayAgo')"> há um dia </a>
            <a v-if="item == 'last_week'" v-text="$ml.get('thisWeek')"> nesta semana </a>
            <a v-if="item == 'last_month'" v-text="$ml.get('lessThanMonthAgo')"> há menos de um mês </a>
          </li>
        </ul>
      </li> 
      
      <li v-if="optionsTags?.length" class='pb-2'>
        <a v-text="$ml.get('filterByTags')"> Tags </a>
        <ul class='none-p-m pt-2 pb-3'>
          <li v-for="(item, index) in optionsTags" :key="index" class="mb-2">  
            <a  @click="item.selected = !item.selected, addTags(item.name)" :class="item.selected ? 'enable-tag' : ''" > {{ capitalizeWord(item.name)?.length > 15 ? capitalizeWord(item.name).split(" ")[0]?.slice(0, 15) +'...' :  capitalizeWord(item.name)}} </a>
          </li>
        </ul>
      </li> 

    </ul>
  </aside> 
</template>

<script>
import ReportService from "../../services/report.service";
export default {
  props: {
    model: {
      type: String,
      required: true,
      default: "all",
    },
  },
  components: { 
  },
  data() {
    return { 
      showFiltersProgram: false,
      txtSearchProgram:"",
      // varS = Selected,
      program_types: [],
      program_typesS: '',
      program: [],
      programS: '',
      severity: [],
      severityS: '',
      status: [],
      statusS: '',
      situations: [],
      situationsS: '',
      period:[],
      periodS: '', 
      optionsTags:[],
      selectedTags:[],
      
    };
  },
  watch:{
    selectedTags(){
      this.$emit('updateTags',{ 
        tags: this.selectedTags,
       }
      ) 
    },
  },
  mounted() { 
    this.changeFilter(); 
  },

  computed:{
    listProgram() {
        if (this.txtSearchProgram) {
          return this.program.filter(p =>
            p.name.toLowerCase().includes(this.txtSearchProgram.toLowerCase())
          );
        }
        return this.program;
      }
  },
  methods: {
    capitalizeWord(word) {
      if (!word) return '';
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    },
    addTags(item){
      if (this.selectedTags.includes(item)) {
        this.selectedTags = this.selectedTags.filter(it => it !== item);
        return;
      }
      this.selectedTags = [...this.selectedTags, item];
    },

    formatObj(obj){
      return obj?.map(item => ({name: item, selected:false}))
    },
     
    changeProgram() {
      if(this.situationsS === this.model) return;

      this.$emit('alterFilter',{ 
        program_types: this.program_typesS, 
        program: this.programS, 
        severity: this.severityS, 
        status: this.statusS, 
        situations: this.situationsS, 
        period: this.periodS,
       }
      ) 
    },
    
    changeFilter(){ 
      ReportService.getListFilters(this.model, {
          locker: true,
          locker_jwt: localStorage.getItem('token_safe')
        })
      .then(
        (response) => { 
       
          let resp = response.data; 

          this.program_types = resp.program_types || [];
          this.program_typesS = resp.program_types?.length == 1 ? resp.program_types[0] : '';
         
          this.program = resp.programs || [];
          this.programS = resp.programs?.length == 1 ? resp.programs[0].program_id : '';

          this.severity = resp.severity || [];
          this.severityS = resp.severity?.length == 1 ? resp.severity[0] : '';

          this.situations = resp.situations || [];
          this.situationsS = resp.situations?.length == 1 ? resp.situations[0] : '';

          this.status = resp.status || [];
          this.statusS = resp.status?.length == 1 ? resp.status[0] : '';

          this.period = resp.period || []; 
          this.periodS = '';
          this.optionsTags = this.formatObj(resp?.tags);
          this.changeProgram();
        }
      ).catch((error) => {
        if(error.response.data.message === 'As credenciais do cofre não são válidas!'){
          localStorage.setItem('token_safe', "");
          localStorage.setItem('remainingTime', '');
        }
      })
    },
  },
};
</script>
<style scoped>
.active{
  color: #E10E71 !important; 
}
.active > a{ 
  font-weight: 500;
}
a{
  cursor: pointer;
}
a:active{
  color: #E10E71 !important;
}
a:hover{
  color: #E10E71 !important;
}
.enable-tag{
  color: #E10E71 !important;
  font-weight: 500;
}
</style>
